import { AudioWavePlayer } from '@/features/studio/components/AudioWavePlayer'

export function AssetAudioWavePlayer({
  src,
  title,
  onError,
  onExpand,
}: {
  src: string
  title: string
  onError?: () => void
  onExpand?: () => void
}) {
  return (
    <AudioWavePlayer
      variant="card"
      src={src}
      title={title}
      onError={onError}
      onExpand={onExpand}
    />
  )
}
